import {action, observable, toJS} from 'mobx';
import * as queryString from 'querystring';
import * as _ from 'lodash';
import {Context} from 'egg';

import {INewsItem} from '../../../components/biz/newsItem/model';
import {fetchNewsList} from '../service';

import {IArticle, IRecommendRemoteRes, IRecommendRemoteResDataItem} from '../../../../service/airiflow';
import {logServer} from '../../../common/logserver';
import {Language} from '../../../../const/env';
import {waAction} from '../../../common/wastat';
import {openNewsWithArticle} from '../../../common/openArticle';

export interface IArticleNewsListStoreInitConfig {
  articleId?: string;
  langAndCountry?: string;
  expectedTotalCount?: number;
  pageSize?: number;
  isShowLoadMoreComponent: boolean;
  adSlotId?: string;
  config?: any;
  scriptSrc?: any;
}

export default class ArticleNewsListStore  {

  @observable public iflowData: IRecommendRemoteRes;
  @observable public articleId: string;
  @observable public langAndCountry: string;
  @observable public expectedTotalCount: number;
  @observable public pageSize: number;
  @observable public isShowLoadMoreComponent: boolean;

  @observable public isLoading: boolean;
  @observable public newsList: INewsItem[];
  @observable public currentPage: number;
  @observable public hasMore: boolean;
  public adSlotId: string;
  public config?: any;
  public scriptSrc?: any;

  private root: any;

  constructor(root: any, initialState: IArticleNewsListStoreInitConfig, advertisingStore) {
    this.root = root;
    this.adSlotId = initialState.adSlotId;
    this.articleId = initialState.articleId;
    this.langAndCountry = initialState.langAndCountry;
    this.expectedTotalCount = initialState.expectedTotalCount || 30;
    this.pageSize = initialState.pageSize || 5;
    this.isShowLoadMoreComponent = false;
    if (initialState.isShowLoadMoreComponent !== undefined && initialState.isShowLoadMoreComponent !== null) {
      this.isShowLoadMoreComponent = initialState.isShowLoadMoreComponent;
    }

    this.isLoading = false;
    this.newsList = [];
    this.currentPage = 0;
    this.hasMore = false;
    this.config = advertisingStore && advertisingStore.config;
    this.scriptSrc = advertisingStore && advertisingStore.scriptSrc;
    // this.newsList = mockNewsList;
  }

  @action.bound
  public async ssrInit(initialState: IArticleNewsListStoreInitConfig, ctx: Context) {
    if (initialState.articleId) { this.articleId = initialState.articleId; }
    if (initialState.langAndCountry) { this.langAndCountry = initialState.langAndCountry; }
    if (initialState.expectedTotalCount) { this.expectedTotalCount = initialState.expectedTotalCount; }
    if (initialState.pageSize) { this.pageSize = initialState.pageSize; }
    if (initialState.isShowLoadMoreComponent !== undefined && initialState.isShowLoadMoreComponent !== null) {
      this.isShowLoadMoreComponent = initialState.isShowLoadMoreComponent;
    }
    if (ctx.envi.language === Language.ru) {
      this.adSlotId = ctx.app.config.dataConfig.russiaAdSlots.withinRecommendation;
    }
    this.config = await ctx.service.adService.getAdConfig();
    this.scriptSrc = await ctx.service.adService.getSrciptSrc();
  }
  @action.bound
  public toJson(): IArticleNewsListStoreInitConfig {
    const initConfig: IArticleNewsListStoreInitConfig = {
      articleId: toJS(this.articleId),
      langAndCountry: toJS(this.langAndCountry),
      expectedTotalCount: toJS(this.expectedTotalCount),
      pageSize: toJS(this.pageSize),
      isShowLoadMoreComponent: toJS(this.isShowLoadMoreComponent),
      adSlotId: this.adSlotId,
      config: toJS(this.config),
      scriptSrc: toJS(this.scriptSrc),
    };
    return initConfig;
  }

  @action.bound
  public actionSetLoading(isLoading: boolean): void {
    if (this.isLoading === isLoading) { return ; }
    this.isLoading = isLoading;
  }

  @action.bound
  public async getNewsList(): Promise<void> {
    const customSearch: string = funcGetCustomQueryString(window.location.search, { count: this.expectedTotalCount });
    const reqLink: string = `/${this.langAndCountry}/detail/${this.articleId}/relatedrec${customSearch}`;
    this.actionSetLoading(true);
    try {
      const res: IRecommendRemoteRes = await fetchNewsList({
        apiConfig: { url: reqLink },
        articleId: this.articleId,
        expectedTotalCount: this.expectedTotalCount,
        langAndCountry: this.langAndCountry,
      });
      const recoGuidingList: IRecommendRemoteResDataItem[] = res.data.items;
      let newsList: INewsItem[] = [];
      if (recoGuidingList === undefined || recoGuidingList === null || recoGuidingList.length === 0) {
        newsList = [];
      }
      recoGuidingList.forEach((recoItem: IRecommendRemoteResDataItem) => {
        if (recoItem.map === 'articles') {
          const tempItem: any = _.find(res.data.articles, (articleItem: IArticle) => {
            return articleItem.id === recoItem.id;
          });
          if (tempItem !== undefined && tempItem !== null) {
            newsList.push(tempItem);
          }
        }
      });
      this.iflowData = res;
      this.newsList = newsList;
      this.currentPage = 0;
      this.hasMore = funcJudgeHasMore(newsList.length, this.pageSize, 0);
      if (newsList.length === 0) {
        console.log(`[ 数据提醒 ] 推荐列表数据为空`);
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.actionSetLoading(false);
    }
  }

  @action.bound
  public uiLoadMore(): void {
    console.log('>uiLoadMore', this.hasMore, this.pageSize, this.newsList);
    if (this.hasMore === false) { return ; }
    if (this.pageSize === undefined || this.pageSize === null || this.pageSize === 0) { return ; }
    if (this.newsList === undefined || this.newsList === null || this.newsList.length === 0) { return; }
    const nextCurrentPage: number = this.currentPage + 1;
    this.currentPage = nextCurrentPage;
    this.hasMore = funcJudgeHasMore(this.newsList.length, this.pageSize, nextCurrentPage);
    clickMoreStat(this.currentPage);
  }

  @action.bound
  public logShowNewsList(): void {
    const iflowData: IRecommendRemoteRes = this.iflowData;
    if (iflowData === undefined || iflowData === null) { return ; }
    let item_ids: string[] = [];
    let item_list: IFuncLogLoadNewsListParamsItemList[] = [];
    if (this.newsList.length > 0) {
      const newsList: INewsItem[] = this.newsList;
      item_ids = newsList.map((newsItem: INewsItem) => {
        return newsItem.id;
      });
      item_list = newsList.map((newsItem: INewsItem) => {
        return {
          cate_id: toJS(newsItem.category_ids),
          item_id: newsItem.id,
          item_type: newsItem.item_type + '',
          trace_item: newsItem.trace_item,
        };
      });
    }
    const logParams: IFuncLogLoadNewsListParams = {
      ac: 'show',
      reco_id: iflowData.data.recoid,
      item_ids: JSON.stringify(item_ids),
      app: 'browser_detailrec',
      trace_pv: iflowData.data.trace_pv,
      item_list: JSON.stringify(toJS(item_list)),
    };
    logServer(logParams, {app: 'browser_detailrec'});
  }

  @action.bound
  public logClickNews(item_id: string, trace_item: string): void {
    const iflowData: IRecommendRemoteRes = this.iflowData;
    const previousQuery: string = window.location.search;
    let originQuery: string = previousQuery;
    if (previousQuery.indexOf('?') === 0) {
      originQuery = previousQuery.slice(1);
    }
    const parsed = queryString.parse(originQuery);
    const logParams: IFuncLogClickNewsParams = {
      ac: 'clk',
      reco_id: iflowData.data.recoid,
      entry2: (parsed.entry2 as string) || '',
      item_id,
      app: 'browser_detailrec',
      trace_pv: iflowData.data.trace_pv,
      trace_item,
    };
    logServer(logParams, {app: 'browser_detailrec'});
  }

  @action.bound
  public onClickNews(news: INewsItem) {
    console.log('>onClickNews', JSON.stringify(news, null, 4));
    this.logClickNews(news.id, news.trace_item);
    setTimeout(() => {
      // wait for logserver finish
      openNewsWithArticle(news, true);
    }, 200);
  }

}

function funcGetCustomQueryString(previousQuery: string, targetObject: any): string {
  if (!process.env.BROWSER) { return ''; }
  let originQuery: string = previousQuery;
  if (previousQuery.indexOf('?') === 0) {
    originQuery = previousQuery.slice(1);
  }
  const parsed = queryString.parse(originQuery);
  _.forEach(targetObject, (queryVal: string, queryKey: string) => {
    parsed[queryKey] = queryVal;
  });
  let resQueryString: string = '';
  _.forEach(parsed, (queryVal: string, queryKey: string) => {
    if (queryKey !== '' && queryKey !== '?') {
      resQueryString += `&${queryKey}=${queryVal}`;
    }
  });
  if (resQueryString.length >= 1) {
    return '?' + resQueryString.slice(1);
  }
  return '';
}

function funcJudgeHasMore(listLength: number, pageSize: number, currentPage: number): boolean {
  if ((currentPage + 1) * pageSize < listLength) { return true; }
  return false;
}

interface IFuncLogLoadNewsListParamsItemList {
  cate_id: string[];
  item_id: string;
  item_type: string;
  trace_item: string;
}
interface IFuncLogLoadNewsListParams {
  ac: string;
  reco_id: string;
  item_ids: string;
  app: string;
  trace_pv: string;
  item_list: string; // IFuncLogLoadNewsListParamsItemList
}
// function funcLogLoadNewsList(params: IFuncLogLoadNewsListParams): void {
//   logServer(params as any);
// }

export interface IFuncLogClickNewsParams {
  ac: string;
  reco_id: string;
  entry2: string;
  item_id: string;
  app: string;
  trace_pv: string;
  trace_item: string;
}
// function funcLogClickNews(params: IFuncLogClickNewsParams): void {
//   logServer(params as any);
// }

export function clickMoreStat(nextPage) {
  waAction({
    ac_name: 'click',
    ac_type: 'related_more',
    page_num: nextPage,
  });
}
